export default "<div id=\"deployments-page\">\n  <router-outlet></router-outlet>\n</div>\n";